/*
 * Copyright © 2015-2022 Serenova, LLC. All rights reserved.
 */

/*
 * Amr Form Messages
 *
 * This contains all the text for the InviteAccept component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  addLock: {
    id: 'amr.addLock',
    defaultMessage: 'I understand locked artifacts cannot be moved or deleted, are exempt from Artifacts Lifecycle Policies, and are subject to data storage usage costs.'
  },
  removeLock: {
    id:'amr.removeLock',
    defaultMessage:'I understand unlocked artifacts may be deleted by an Artifacts Lifecycle Policy and cannot be retrieved once deleted.'
  },
  delete: {
    id: 'amr.delete',
    defaultMessage: 'I understand deleted artifacts cannot be retrieved.'
  }
});